import type { ServerEnvConfigType } from '@/shared/config/ServerEnvConfigType';
import { Any } from '@/shared/constant/any';
import { createContextStore } from '@/shared/util/createContextStore';

export type EnvConfigState = ServerEnvConfigType;

export type EnvConfigAction = {};

const [EnvConfigModelStoreProvider, useEnvConfigModelStore] = createContextStore<
  EnvConfigState,
  EnvConfigAction
>(
  () => ({
    ...Any,
  }),
  false,
);

export { EnvConfigModelStoreProvider, useEnvConfigModelStore };
